import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AssessmentPage from "@/pages/AssessmentPage";
import CoachingApplicationPage from "@/pages/CoachingApplicationPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import RecipesLandingPage from "@/pages/recipes/RecipesLandingPage";
import RecipesSuccessPage from "@/pages/recipes/RecipesSuccessPage";
import RecipesLoginPage from "@/pages/recipes/RecipesLoginPage";
import RecipesDashboardPage from "@/pages/recipes/RecipesDashboardPage";
import ServicesPage from "@/pages/ServicesPage";
import GalleryPage from "@/pages/GalleryPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import FloatingWhatsAppButton from "@/components/FloatingWhatsAppButton";
import PromoPopup from "@/components/PromoPopup";
import { AuthProvider } from "@/context/AuthContext";

function App() {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/assessment" element={<AssessmentPage />} />
            <Route path="/the-test" element={<AssessmentPage />} />
            <Route path="/coaching-application" element={<CoachingApplicationPage />} />
            <Route path="/nutrition-application" element={<CoachingApplicationPage />} />
            <Route path="/recipes" element={<RecipesLandingPage />} />
            <Route path="/recipes/success" element={<RecipesSuccessPage />} />
            <Route path="/recipes/login" element={<RecipesLoginPage />} />
            <Route path="/recipes/dashboard" element={<RecipesDashboardPage />} />
            <Route path="/coaching/success" element={<PaymentSuccessPage />} />
            <Route path="/programs" element={<ServicesPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Footer />
          <FloatingWhatsAppButton />
          {/* PromoPopup disabled — homepage redesigned to focus on posing intensive, not pricing */}
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
